export default __webpack_public_path__ + "static/media/stolen-purple.838af671.svg";